import React from "react"
import Img from "react-image"
import { BrowserView, MobileView } from "react-device-detect"
import PropTypes from "prop-types"
import { Spinner } from "../../spinner"
import withModal from "../../modal"

const Image = ({ src, className, style }) => {
  return (
    <div className={className}>
      <BrowserView>
        <Img
          onClick={() => {
            setTimeout(() => {
              const response = {
                file: `http://VIP.getech.com.tw:6000/download?file=${src}`
              }
              window.open(response.file)
            }, 100)
          }}
          src={src}
          style={
            style || {
              width: "auto",
              height: "auto",
              maxWidth: "320px",
              maxHeight: "320px"
            }
          }
          loader={<Spinner />}
          className="unselectable pointer"
        />
      </BrowserView>
      <MobileView>
        <Img
          onClick={() => {
            setTimeout(() => {
              const response = {
                file: `http://VIP.getech.com.tw:6000/download?file=${src}`
              }
              window.open(response.file)
            }, 100)
          }}
          src={src}
          style={
            style || {
              width: "auto",
              height: "auto",
              maxWidth: `${window.innerWidth - 185}px`,
              maxHeight: `${window.innerWidth - 185}px`
            }
          }
          loader={<Spinner />}
          className="unselectable pointer"
        />
      </MobileView>
    </div>
  )
}

Image.propTypes = {
  src: PropTypes.string.isRequired,
  // name: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
  // modal: PropTypes.object.isRequired
}

export default withModal(Image)
